import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class BannerContainer extends React.PureComponent {
    state = {
        bannerClassName: styles.banner,
    };
    static propTypes = {
        animateConfig: PropTypes.object,
    };

    static defaultProps = {
        animateConfig: {
            bannerFix: false,
        },
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { animateConfig } = this.props;
        /**
         * 组件分发数据
         */

        return <div className={animateConfig.bannerFix ? styles.bannerFix : styles.banner} />;
    }
}

export default errorBoundary(BannerContainer);
